// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0ad027b8","455":"75d86f24"}[chunkId] + ".chunk.js";
};